import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { PROP_TYPES, type PropType } from '../constants';
import { PROP_ICONS } from './propMeta';

const { Text } = Typography;

interface PropPaletteProps {
  onAdd: (type: PropType) => void;
  disabled?: boolean;
}

/** Sol palet — 6 prop tipi (Forms FieldPalette deseni). */
export function PropPalette({ onAdd, disabled }: PropPaletteProps) {
  const { t } = useTranslation('component-studio');
  return (
    <div>
      <Text strong>{t('builder.palette')}</Text>
      <div style={{ fontSize: 12, color: 'var(--ds-text-tertiary)', marginBottom: 10 }}>
        {t('builder.paletteHint')}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {PROP_TYPES.map((type) => (
          <Button
            key={type}
            block
            icon={PROP_ICONS[type]}
            disabled={disabled}
            onClick={() => onAdd(type)}
            style={{ justifyContent: 'flex-start', textAlign: 'left' }}
            data-testid={`prop-palette-${type}`}
          >
            {t(`builder.propType.${type}`)}
          </Button>
        ))}
      </div>
    </div>
  );
}
